import React from 'react'
import { generatePageNumbers } from './utilities';
import { concatParamsToUrl, redirectTo } from 'src/utils/Http';

const ClientPagination = (props) => {

    const { clientPerPage, totalClients, currentPage, url } = props;
    const pageNumbers = [];
    const arrPageNumbers = generatePageNumbers(totalClients, clientPerPage, pageNumbers);
    const firstPage = arrPageNumbers[0];
    const lastPage = arrPageNumbers[pageNumbers.length - 1];
    const page = currentPage;
	const paginate = page => {
        redirectTo(concatParamsToUrl(url, { page: page }))
    };
    return (
        <div>
            <nav aria-label="...">
                <ul className="pagination">
                    <li className={`page-item ${parseInt(page) === firstPage ? "disabled" : ""}`}>
                        <button onClick={()=>{paginate(parseInt(page) - 1)}} className="page-link" tabIndex="-1">Previous</button>
                    </li>
                    {arrPageNumbers.map((pageNum) => {
                       return <li key={pageNum} className={`page-item ${parseInt(page) === pageNum ? "active" : ""}`}>
                                <a className={`page-link ${page === pageNum ? "text-white" : ""}`} onClick={()=>{paginate(pageNum)}}  >{pageNum}</a>
                            </li>
                    })}
                    <li className={`page-item ${parseInt(page) === lastPage ? "disabled" : ""}`}>
                        <button onClick={()=>{paginate(parseInt(page) + 1)}} className="page-link">Next</button>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default ClientPagination
